import {Injectable} from '@angular/core';
import {Code} from '../../models/code.model';
import {environment} from '../../../environments/environment';
import {BaseAbstractService} from './base-abstract.service';

@Injectable()
export class SupportTypeService extends BaseAbstractService
{
  _codes:Code[];

  _default:string = "SUPPORT";
  get url():string {
    return environment.backendURL + environment.supportPath+ this.configService.appConfig.apiUrl + 'Support/SupportTypes/';
  }

  async findAll(): Promise<Code[]> {
    this._codes= this._codes ? this._codes: await this.get<Code[]>(`${this.url}`);
    return this._codes;
  }

  get default():Code{
    return this._codes.find((code)=>{
      return this._default==code.code?true:false;
    })||this._codes[0];
  }
}
